module.exports = __webpack_public_path__ + "img/1.7880e47b.png";